import React from 'react';
import LinkEffect from '../../commons/LinkEffect';

const ButtonVideo = () => <LinkEffect to="/videos"><div className="ButtonVideo" /></LinkEffect>

export { ButtonVideo }
export default ButtonVideo



// WEBPACK FOOTER //
// ./src/components/360Mode/IndexView/ButtonVideo.js